<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="fit-content"
    maxWidth="90%"
    class="bg-white"
    :content-class="isDarkMode ? 'dark-mode' : ''"
  >
  
  <ReportCard 
  :restartSessionClicked="restartSessionClicked"
          :statusResults="statusResults"
          :screenType="screenType"
          />
    
  </v-dialog>
</template>

<script>
import { parseTime, bytesToSize } from '@/utils'
import { mapGetters } from 'vuex'
import { DownloadReport, downloadFilesIndividual } from '../../Websiteinterface'

//Base Components
import Button from '@/components/BaseComponents/Button/Button.vue'
import Summary from '@/components/BaseComponents/Summary/Summary.vue'

import DynamicFieldsDialog from '@/components/WebsiteInterface/CommonComponents/DynamicFieldsDialog/DynamicFieldsDialog.vue'
import ReportCard from './Children/ReportCard.vue'

export default {
  name: 'UploadReportDialog',
  data() {
    return {
      dialog: true,
      isShowFullReport: false,
      fullReport: null,
    }
  },
  components: { Button, Summary, DynamicFieldsDialog, ReportCard },
  props: {
    restartSessionClicked: Function,
    statusResults: Object,
    screenType: String,
  },
  filters: {
    parseTime,
    bytesToSize,
  },
  computed: {
    ...mapGetters([
      'accessibility',
      'loggedUser',
      'isDarkMode',
      'language',
      // 'interactiveInterfaceFields',
    ]),
    isShowSentToCasuals() {
      if (this.loggedUser.role === 'SuperAdmin') return false
      else if (this.loggedUser.role === 'Individual') return false
      else if (this.statusResults.session.selectedCasualUsers.length === 0)
        return false
      // else if (this.loggedUser.isOrgHasCasuals) return true
      return true
    },
  },
  methods: {
    async downloadReportClicked() {
      DownloadReport(this.statusResults.session.htmlReport)
    },
    downloadIndividualFiles() {
      downloadFilesIndividual(this, this.statusResults.session.operationId)
    },
  },
}
</script>

<style scoped src="./UploadReportDialog.css"></style>
